import {dom} from '../constant/dom';
import Swiper from 'swiper/bundle';

export default () => {
	let cardSliders = document.querySelectorAll('.js-card-slider');
	const sliderPrefix = 'products__';
	const SLIDE_SPEED = 600;

	cardSliders.forEach(function(sliderEl) {
		const btnPrev = sliderEl.querySelector('.products__nav-btn--prev');
		const btnNext = sliderEl.querySelector('.products__nav-btn--next');
		const paginationEl = sliderEl.querySelector('.pagination');

		if (window.innerWidth > +dom.mq.mobile) {
			const slides = sliderEl.querySelectorAll('.products__slide');
			if (slides) {
				slides[0].remove();
			}
		}

		const slider = new Swiper(sliderEl, {
			wrapperClass: `${sliderPrefix}slider-wrapper`,
			slideClass: `${sliderPrefix}slide`,
			slideActiveClass: `${sliderPrefix}slide--active`,
			slidesPerView: 1,
			loop: true,
			speed: SLIDE_SPEED,
			navigation: {
				prevEl: btnPrev,
				nextEl: btnNext
			},
			pagination: {
				el: paginationEl,
				type: 'bullets',
				clickable: true,
				bulletClass: 'pagination__bullet',
				bulletActiveClass: 'pagination__bullet--active'
			},
		});
	});


	// load slider images on hover
	document.addEventListener('mousemove', (e) => {
		if (e.target.closest('.js-card')) {
			const card = e.target.closest('.js-card');
			const images = card.querySelectorAll('[data-src]');

			images.forEach(function(image) {
				if (!image.classList.contains('is-loaded')) {
					image.src = image.dataset.src;
					image.classList.add('is-loaded')
				}
			});
		}
	});
	document.addEventListener('touchstart', (e) => {
		if (e.target.closest('.js-card')) {
			const card = e.target.closest('.js-card');
			const images = card.querySelectorAll('[data-src]');

			images.forEach(function(image) {
				if (!image.classList.contains('is-loaded')) {
					image.src = image.dataset.src;
					image.classList.add('is-loaded')
				}
			});
		}
	});
}